// Mock data for New Space UK clone (frontend-only)

export const NAV_LINKS = [
  { label: "Home", type: "section", target: "home" },
  { label: "Landlords", type: "dropdown", target: "landlords", children: [
    { label: "Fees & Services", to: "/landlords" },
    { label: "HMO & Licensing Guide", to: "/landlords/hmo-licensing-hackney" },
    { label: "MyNewSpace App", to: "/mynewspace" },
  ] },
  { label: "Tenants", type: "dropdown", target: "tenants", children: [
    { label: "Property to Rent", type: "section", target: "tenants" },
    { label: "MyNewSpace App", to: "/mynewspace" },
  ] },
  { label: "Property Alerts", type: "modal", target: "register" },
  { label: "Valuation", type: "route", target: "/valuation" },
  { label: "About Us", type: "section", target: "about" },
  { label: "Contact Us", type: "section", target: "contact" },
];

export const LANDLORD_SERVICES = [
  {
    name: "Let Only",
    tagline: "We find and set up the right tenant",
    highlight: false,
    points: [
      "Sole agency basis",
      "Professional photography & marketing",
      "Accompanied viewings",
      "Referencing & Right to Rent",
      "Electronic tenancy agreement",
      "Deposit registration included",
    ],
  },
  {
    name: "Rent Collection",
    tagline: "We find your tenant and collect the rent",
    highlight: false,
    points: [
      "Everything in Let Only, plus:",
      "Monthly collection of rent",
      "Monthly & yearly financial statements",
      "Rent arrears advice & tenancy protection",
      "Section 13 rent-increase notices included",
      "Arrangement of other outgoings",
    ],
  },
  {
    name: "Full Management",
    tagline: "A completely hands-off service",
    highlight: true,
    points: [
      "Everything in Rent Collection, plus:",
      "Instruction of repairs & recommended contractors",
      "24-hour emergency service & key-holding",
      "Periodic property check-ups & legal notices",
      "Check-out & deposit deduction management",
      "Smooth re-letting process",
    ],
  },
];

export const AREA_GUIDES = [
  {
    slug: "london-fields",
    name: "London Fields",
    postcode: "E8",
    tagline: "Letting agents in London Fields",
    image: "https://images.estatesit.uk/https://www.newspaceuk.com/content/images/slideshow/2.jpg?Format=webp",
    fallback: "https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "London Fields is one of Hackney\u2019s most sought-after neighbourhoods, built around its namesake park, the famous lido and the buzz of Broadway Market every Saturday. It\u2019s a favourite with young professionals, creatives and families who want green space and independent shops on their doorstep.",
      "As an independent lettings and management specialist based moments away in Haggerston, New Space knows London Fields inside out \u2014 from the Victorian terraces off Wilton Way to the warehouse conversions near the railway. We know what tenants here are looking for and how to price and present a property to let it quickly.",
      "Whether you\u2019re a landlord with a single flat or a growing portfolio, we combine genuine local knowledge with proactive management to protect and grow your investment in E8.",
    ],
    highlights: ["London Fields park & lido", "Broadway Market", "Independent cafes & pubs", "London Fields Overground"],
    transport: "London Fields & Hackney Central Overground \u00b7 easy access to Liverpool Street",
  },
  {
    slug: "dalston",
    name: "Dalston",
    postcode: "E8",
    tagline: "Letting agents in Dalston",
    image: "https://images.unsplash.com/photo-1622109913183-42ce5f3767b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    fallback: "https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "Dalston is the beating heart of east London\u2019s nightlife and culture \u2014 a lively mix of Ridley Road Market, independent music venues, rooftop bars and some of the best food in the city. Excellent transport links make it a magnet for renters who want energy on their doorstep.",
      "New Space has let and managed homes across Dalston for years, from period conversions around Kingsland Road to modern apartments near the stations. We understand the fast-moving local market and the strong tenant demand that comes with it.",
      "For landlords, that means confident pricing, high-quality marketing and dependable management \u2014 all from a friendly, senior point of contact who knows the area personally.",
    ],
    highlights: ["Ridley Road Market", "Kingsland Road bars & food", "Dalston Junction & Kingsland stations", "Vibrant nightlife"],
    transport: "Dalston Junction & Dalston Kingsland Overground \u00b7 minutes to the City",
  },
  {
    slug: "hackney-wick",
    name: "Hackney Wick",
    postcode: "E9",
    tagline: "Letting agents in Hackney Wick",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/bn4rz1jb_image.webp",
    fallback: "https://images.unsplash.com/photo-1622109913183-42ce5f3767b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "Hackney Wick is London\u2019s creative frontier \u2014 canalside warehouses, artists\u2019 studios, breweries and waterside bars, all beside the green expanse of Queen Elizabeth Olympic Park. Its distinctive character and regeneration have made it one of the most exciting places to rent in east London.",
      "New Space lets and manages a range of homes here, from converted warehouse apartments along the Regent\u2019s Canal to contemporary new-builds near the park. We know how to showcase these unique properties and reach the right tenants.",
      "If you own an investment in E9, our tailored management keeps rent flowing, void periods low and your property performing \u2014 backed by London-wide reach through our partnership with HAUS Block Management.",
    ],
    highlights: ["Regent\u2019s Canal & waterside bars", "Queen Elizabeth Olympic Park", "Warehouse & studio living", "Hackney Wick Overground"],
    transport: "Hackney Wick Overground \u00b7 walking distance to Stratford",
  },
  {
    slug: "islington",
    name: "Islington",
    postcode: "N1",
    tagline: "Letting agents in Islington",
    image: "https://images.unsplash.com/photo-1512845296467-183ccf124347?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    fallback: "https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "Islington is one of north London\u2019s most desirable addresses \u2014 elegant Georgian squares, the buzz of Upper Street\u2019s bars and theatres, Chapel Market and the leafy calm of Highbury Fields. It draws professionals and families who want period charm with the West End on their doorstep.",
      "New Space lets and manages homes throughout Islington and neighbouring De Beauvoir, from classic conversion flats to smart new developments around Angel and Highbury & Islington. We understand the premium tenants here expect and how to present a home to match.",
      "For landlords, our tailored, hands-on management keeps your Islington investment performing \u2014 with confident pricing, standout marketing and a single senior point of contact who knows the area personally.",
    ],
    highlights: ["Upper Street & Angel", "Chapel Market", "Highbury Fields", "Angel & Highbury & Islington stations"],
    transport: "Angel (Northern) & Highbury & Islington (Victoria/Overground) \u00b7 direct to the City & West End",
  },
  {
    slug: "the-city",
    name: "The City",
    postcode: "EC",
    tagline: "Letting agents in the City of London",
    image: "https://images.unsplash.com/photo-1533929736458-ca588d08c8be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    fallback: "https://images.unsplash.com/photo-1622109913183-42ce5f3767b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "The City of London \u2014 the Square Mile \u2014 combines world-famous landmarks with a fast-growing residential scene. Sleek apartments around Barbican, Aldgate and the riverside appeal to City professionals who want to live moments from work, with restaurants, culture and transport all around.",
      "New Space lets and manages contemporary City apartments and conversions, marketing them to the corporate and professional tenants who value this location. We know how to move quickly in a market where demand is high and timing matters.",
      "Whether you own a pied-\u00e0-terre or an investment portfolio, our proactive management protects your asset and keeps rent flowing \u2014 with London-wide reach through our partnership with HAUS Block Management.",
    ],
    highlights: ["Barbican & Aldgate living", "Riverside & Tower Bridge", "World-class transport", "Restaurants & culture"],
    transport: "Liverpool Street, Moorgate, Bank & the Elizabeth line \u00b7 unrivalled connections",
  },
  {
    slug: "shoreditch",
    name: "Shoreditch",
    postcode: "E1/EC2",
    tagline: "Letting agents in Shoreditch",
    image: "https://images.unsplash.com/photo-1525953776754-6c4b7ee655ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    fallback: "https://images.unsplash.com/photo-1622109913183-42ce5f3767b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "Shoreditch is east London\u2019s creative and tech powerhouse \u2014 street art, rooftop bars, Boxpark, Brick Lane and Old Street\u2019s start-up scene. Its warehouse loft apartments and design-led new-builds are hugely popular with young professionals and creatives.",
      "Based just up the road, New Space knows Shoreditch and neighbouring Hoxton exceptionally well. We showcase these distinctive homes with professional marketing and reach the right tenants fast in one of the capital\u2019s most competitive rental markets.",
      "For landlords, that means strong achievable rents, minimal void periods and dependable management \u2014 all delivered with the personal, boutique service New Space is known for.",
    ],
    highlights: ["Brick Lane & Boxpark", "Old Street tech scene", "Warehouse loft living", "Shoreditch High Street Overground"],
    transport: "Old Street, Liverpool Street & Shoreditch High Street \u00b7 fast links across London",
  },
  {
    slug: "stoke-newington",
    name: "Stoke Newington",
    postcode: "N16",
    tagline: "Letting agents in Stoke Newington",
    image: "https://images.unsplash.com/photo-1512845296467-183ccf124347?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    fallback: "https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    paragraphs: [
      "Stoke Newington is one of north London\u2019s most characterful villages \u2014 the independent shops and cafes of Church Street, the green expanse of Clissold Park and the historic Abney Park all give N16 a relaxed, community feel that families and professionals love.",
      "New Space lets and manages homes throughout Stoke Newington, from handsome Victorian terraces and period conversions to contemporary apartments. We know exactly what tenants here are looking for and how to present a property to let it quickly and at the right price.",
      "For landlords, our tailored, hands-on management keeps your N16 investment performing \u2014 with confident pricing, standout marketing and one experienced point of contact who knows the area personally.",
    ],
    highlights: ["Church Street shops & cafes", "Clissold Park", "Abney Park", "Excellent bus & rail links"],
    transport: "Stoke Newington & Rectory Road rail \u00b7 quick links to Liverpool Street",
  },
];

export const LANDLORD_FAQ = [
  {
    q: "How much does New Space charge landlords?",
    a: "Our fees are tailored to your needs and the size of your portfolio, so we\u2019ll always give you a clear, bespoke quote up front. We offer three service levels \u2014 Let Only, Rent Collection and Full Management \u2014 and never charge tenants a letting, renewal or admin fee.",
  },
  {
    q: "Which areas do you cover?",
    a: "We\u2019re based in Haggerston and specialise in London Fields, Dalston, De Beauvoir, Hoxton, Stoke Newington, Hackney Central, Hackney Wick and Clapton. Through our partnership with HAUS Block Management we also let and manage properties across Greater London within the M25.",
  },
  {
    q: "What\u2019s the difference between your service levels?",
    a: "Let Only finds and sets up the right tenant. Rent Collection adds monthly rent collection, statements and arrears support. Full Management is completely hands-off \u2014 we handle repairs, contractors, 24-hour emergencies, inspections, legal notices and the check-out too.",
  },
  {
    q: "How quickly can you let my property?",
    a: "With professional photography, standout marketing across the major portals and accompanied viewings, well-presented properties in our core areas often let within days. We\u2019ll advise on pricing and presentation to minimise void periods.",
  },
  {
    q: "What safety certificates do I need as a landlord?",
    a: "You\u2019ll typically need a valid Gas Safety Certificate, an Electrical (EICR) report and an EPC rated E or above, plus fire-safety compliant furnishings. We arrange all of these compliance checks as part of our service \u2014 you only pay the engineer\u2019s or assessor\u2019s own fee.",
  },
  {
    q: "How and when do I get paid?",
    a: "Rent is processed and paid to you within five working days of clearing in our account, with monthly and yearly statements, plus access to our online landlord portal so you can see all your documents in one place.",
  },
];

export const LANDLORD_COMPARISON = [
  {
    group: "Marketing",
    rows: [
      { label: "Professional photography", full: "yes", rent: "yes", let: "yes" },
      { label: "Comprehensive marketing", full: "yes", rent: "yes", let: "yes" },
      { label: "Accompanied viewings", full: "yes", rent: "yes", let: "yes" },
      { label: "Marketing feedback & updates", full: "yes", rent: "yes", let: "yes" },
    ],
  },
  {
    group: "Tenant Finding",
    rows: [
      { label: "Tenant finding", full: "yes", rent: "yes", let: "yes" },
      { label: "Progression to move-in", full: "yes", rent: "yes", let: "yes" },
      { label: "Comprehensive referencing", full: "yes", rent: "yes", let: "yes" },
      { label: "Right to Rent checks", full: "yes", rent: "yes", let: "yes" },
      { label: "Tenancy agreement", full: "yes", rent: "yes", let: "yes" },
      { label: "Paperless legal process", full: "yes", rent: "yes", let: "yes" },
      { label: "Professional cleaning arranged", full: "yes", rent: "yes", let: "yes" },
      { label: "Certification & compliance arranged", full: "yes", rent: "yes", let: "yes" },
      { label: "Inventory & check-in arranged", full: "yes", rent: "yes", let: "yes" },
    ],
  },
  {
    group: "Tenancy",
    rows: [
      { label: "Issue Section 13 notice (rent increase)", full: "yes", rent: "yes", let: "addon" },
      { label: "Manage rent review if tenant disputes", full: "yes", rent: "yes", let: "addon" },
      { label: "Deposit registration", full: "yes", rent: "yes", let: "yes" },
      { label: "Rent arrears advice", full: "yes", rent: "yes", let: "no" },
      { label: "Tenancy protection service", full: "yes", rent: "yes", let: "no" },
      { label: "Monthly & yearly financial statements", full: "yes", rent: "yes", let: "no" },
      { label: "Collection of rent", full: "yes", rent: "yes", let: "no" },
      { label: "Arrangement of outgoings", full: "yes", rent: "yes", let: "no" },
    ],
  },
  {
    group: "Management",
    rows: [
      { label: "Management fees paid monthly", full: "yes", rent: "yes", let: "no" },
      { label: "Instruction of repairs & maintenance", full: "yes", rent: "no", let: "no" },
      { label: "Recommended contractors", full: "yes", rent: "no", let: "no" },
      { label: "24-hour emergency service", full: "yes", rent: "no", let: "no" },
      { label: "Key-holding service", full: "yes", rent: "no", let: "no" },
      { label: "Periodic property check-up", full: "yes", rent: "no", let: "no" },
      { label: "Legal notices", full: "yes", rent: "no", let: "no" },
      { label: "Utility management service", full: "yes", rent: "no", let: "no" },
      { label: "Management of the check-out", full: "yes", rent: "no", let: "no" },
      { label: "Deposit deduction advice", full: "yes", rent: "no", let: "no" },
      { label: "HMO monitoring & advice", full: "yes", rent: "no", let: "no" },
    ],
  },
];

export const LANDLORD_INCLUDED = [
  { icon: "Camera", title: "Professional Photography", text: "High-quality images to showcase your property and attract the strongest applicants." },
  { icon: "Megaphone", title: "Comprehensive Marketing", text: "A full campaign across all major portals and our own channels to maximise exposure." },
  { icon: "Users", title: "Accompanied Viewings", text: "We accompany every applicant and give you regular feedback and updates." },
  { icon: "ShieldCheck", title: "Referencing & Right to Rent", text: "Comprehensive referencing, credit checks and statutory Right to Rent verification." },
  { icon: "FileSignature", title: "Electronic Tenancy Agreement", text: "A paperless legal process \u2014 tenancy prepared and executed electronically." },
  { icon: "Sparkles", title: "Cleaning & Compliance", text: "Professional cleaning arranged on request; certification and compliance coordinated." },
];

export const LANDLORD_PROCESS = {
  title: "Our Process",
  intro:
    "A successful tenancy doesn\u2019t happen by chance. It comes from the right strategy, precise execution and proactive management from the very first conversation.",
  steps: [
    {
      n: "01",
      icon: "Compass",
      title: "Start with the Right Strategy",
      text: "Every instruction begins with an honest appraisal. We\u2019ll advise on pricing, presentation and any improvements worth making, so your property launches with the strongest possible chance of attracting the right tenant.",
    },
    {
      n: "02",
      icon: "Rocket",
      title: "Launch at the Right Time",
      text: "First impressions matter. From professional photography and standout marketing to choosing the right launch date and managing competing offers, every decision is made to maximise interest and minimise void periods.",
    },
    {
      n: "03",
      icon: "ShieldCheck",
      title: "Protect Your Investment",
      text: "Finding a tenant is only the beginning. We handle referencing, compliance, contracts and day-to-day management with the same attention to detail, keeping rent flowing and your investment performing for the long term.",
    },
  ],
  closingTitle: "Why landlords stay with us",
  closingText:
    "The majority of our business comes from repeat clients and referrals. We\u2019ve grown by delivering consistent results, clear communication and management that gives landlords confidence long after the keys have been handed over. And you won\u2019t see a \u2018For Let\u2019 board from us \u2014 that\u2019s old hat; we let discreetly and let the results do the talking.",
};

export const HERO = {
  kicker: "Letting Agents in North London",
  title: "LETTING AGENTS IN NORTH LONDON",
  subtitle: "Specialist in independent lettings and management",
  image:
    "https://images.estatesit.uk/https://www.newspaceuk.com/content/images/slideshow/2.jpg?Format=webp",
  fallback:
    "https://images.unsplash.com/photo-1526129318478-62ed807ebdf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};

export const WELCOME = {
  title: "Welcome to New Space",
  image:
    "https://images.estatesit.uk/https://www.newspaceuk.com/CMS/static-img.jpg?format=webp",
  fallback:
    "https://images.unsplash.com/photo-1778375744848-e7757f0254e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  paragraphs: [
    "NewSpace is an independent lettings and property management specialist based in Haggerston, helping landlords across London let, protect and maximise their investment.",
    "We\u2019re deeply rooted in East London, with specialist knowledge of London Fields, Dalston, De Beauvoir, Hoxton, Stoke Newington, Hackney Central, Hackney Wick and Clapton. Through our close partnership with HAUS Block Management, we also let and manage apartments throughout Greater London within the M25, supporting leaseholders, investors and portfolio landlords alike.",
    "Whether you\u2019re letting a single apartment or an entire portfolio, we combine local expertise with London-wide reach, proactive management and straightforward advice to make the process simple from start to finish.",
  ],
};


export const MARKETING_COMPARE = {
  examples: [
    {
      id: "living",
      label: "Living Room",
      before: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/v2kcifh1_NEW%20SPACE%28LOGO%29-9%20IINFINITY%20HEIGHTS%20E8-17.webp",
      after: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/hlou0nwv_ai-enhanced-6aa6eb39d9cef.jpg",
    },
    {
      id: "bathroom",
      label: "Bathroom",
      before: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/pqp19054_NEW%20SPACE%28LOGO%29-9%20IINFINITY%20HEIGHTS%20E8-12.webp",
      after: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/a2zvazcm_ai-enhanced-6aa6f6954377f.jpg",
    },
    {
      id: "bedroom",
      label: "Bedroom",
      before: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/atgv0x39_NEW%20SPACE%28LOGO%29-9%20IINFINITY%20HEIGHTS%20E8-5.webp",
      after: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/patx5oue_ai-enhanced-6aa7e053245b8.jpg",
    },
  ],
  columns: [
    { title: "Included, Not Extra", text: "Professional photography and digital enhancement come as standard on every instruction \u2014 never a paid upgrade or hidden charge." },
    { title: "Faster To Let", text: "Clean, bright, clutter-free listings win more clicks and more viewings, helping your property let quicker and cutting void periods." },
    { title: "Nothing Misrepresented", text: "We only declutter and enhance \u2014 never alter room sizes, layout or structure. What a tenant sees online is what they get in person." },
  ],
};

export const MYNEWSPACE = {
  landlords: {
    features: [
      { icon: "LayoutDashboard", title: "Your whole portfolio, live", desc: "Every property in one dashboard: rent status, tenancy dates and maintenance, all at a glance." },
      { icon: "FileText", title: "Statements, the moment you need them", desc: "Download any month or year, accountant-ready, no waiting on the office to send them over." },
      { icon: "BadgeCheck", title: "Approve repairs with one tap", desc: "See the contractor\u2019s quote, cost and timeline, and approve instantly \u2014 work starts straight away." },
      { icon: "Activity", title: "A complete, real-time record", desc: "Every transaction logged and visible the moment it happens." },
    ],
    phone: {
      greeting: "Good morning, Richard",
      statCards: [
        { label: "Portfolio", value: "4", sub: "properties \u00b7 all let" },
        { label: "Rent this month", value: "\u00a38,450", sub: "received" },
      ],
      repair: { title: "Boiler service \u00b7 Flat 2", meta: "Quote \u00a3180 \u00b7 2 days", status: "Approve", tone: "amber" },
      note: { title: "June statement ready", desc: "Tap to download PDF" },
      action: "Approve repair",
    },
  },
  tenants: {
    features: [
      { icon: "Home", title: "Your tenancy, at a glance", desc: "Rent amount, next payment date and tenancy expiry, always visible." },
      { icon: "Camera", title: "Report a repair in seconds", desc: "Snap a photo and describe the issue, get instant guidance on common problems." },
      { icon: "ListChecks", title: "Track every job to completion", desc: "Real-time status updates as your repair moves from reported to booked to fixed." },
      { icon: "CalendarClock", title: "Know what\u2019s next", desc: "Upcoming inspection dates and who\u2019s attending." },
    ],
    phone: {
      greeting: "Hi Ayesha",
      statCards: [
        { label: "Next rent", value: "\u00a31,650", sub: "due 1 Jul" },
        { label: "Tenancy ends", value: "12 Mar", sub: "2026" },
      ],
      repair: { title: "Leaking tap \u00b7 Kitchen", meta: "Fri 9am \u00b7 confirmed", status: "Booked", tone: "green" },
      note: { title: "Inspection \u00b7 18 Jul", desc: "Kim attending, 10am" },
      action: "Report a repair",
    },
  },
};

export const TEAM = {
  title: "Meet the Team",
  intro:
    "Deal with real people, not a corporate machine. Our senior team looks after every part of your tenancy \u2014 and you\u2019ll always know exactly who to call.",
  members: [
    { name: "Richard", role: "Managing Director", initials: "R", accent: "#ec008c", bio: "The driving force behind New Space, Richard leads the business and personally carries out landlord valuations across Hackney and beyond. Straight-talking and hands-on, he\u2019s built New Space on honest advice, sharp local knowledge and genuine, long-term relationships with landlords.\n\nOutside the office, Richard is a devoted dad \u2014 much of his free time is spent with his son, whether that\u2019s building elaborate LEGO creations together (pictured), cheering him on from the sidelines, or planning their next adventure.", photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/pyvv3u07_image.png", imgPos: "center 15%", photoHover: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/byuy7xbt_fc44ee67-a117-42c6-851f-1cf475c3acd6.jpg", imgPosHover: "center 32%" },
    { name: "George", role: "Head of Lettings", initials: "G", accent: "#35a4a4", bio: "George the Villain \u2014 and proud Aston Villa fan, of course.\n\nGeorge has been part of New Space for over 11 years, joining the business at just 18 as an apprentice. Through hard work, strong market knowledge and a genuine passion for property, he worked his way up to become our Head of Lettings, helping hundreds of landlords and tenants navigate the London rental market.\n\nWhether he\u2019s out carrying out valuations, negotiating deals or leading the lettings team, George brings a calm, straightforward approach and years of hands-on experience to every instruction. He knows the market inside out and prides himself on making the lettings process as smooth and stress-free as possible.\n\nOutside of work, George is a family man through and through. He loves spending time with his daughter, walking his blonde sausage dog, Steve, and fitting in a round of golf whenever he can. He\u2019s also partial to a pint in Ireland, can never say no to a good bowl of ramen, and proudly considers avoiding the gym one of his greatest talents.\n\nAnd yes, he\u2019s an Aston Villa fan \u2014 nobody\u2019s perfect.", photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/yltxfqcb_37f871d2-3a58-433c-9134-351d33396140.jpg", imgPos: "center 24%" },
    { name: "Kim", role: "Head of Property Management", initials: "K", accent: "#eaa32a", bio: "If there\u2019s one person you want in your corner when it comes to property management, it\u2019s Kim. With over 12 years at New Space, she knows our portfolio inside out and has seen just about every maintenance issue, tenancy challenge, and compliance question imaginable.\n\nA true safe pair of hands, Kim\u2019s experience, attention to detail, and no-nonsense approach keep both landlords and tenants in good hands. Ask her about a property in our portfolio and there\u2019s a good chance she\u2019ll know exactly which one you\u2019re talking about before you\u2019ve finished the address.\n\nArguably one of the best in the business... at least that\u2019s what she\u2019ll tell you.\n\nWhen she\u2019s away from the office, you\u2019ll usually find Kim cheering on the Springboks, proving that her competitive streak doesn\u2019t stop when the working day ends.", photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/pby6osoa_14829f8a-4ba2-4f8b-898a-80c379ade33b.png", imgPos: "center 18%", photoHover: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/1ev9vn1k_image.png", imgPosHover: "36% 28%" },
    { name: "Yasaar", role: "Lettings Accounts", initials: "Y", accent: "#16323f", bio: "If there\u2019s one person who can keep things running smoothly while everyone else is spinning plates, it\u2019s Yasaar. With over 20 years of bookkeeping and accounts experience \u2014 five of them here at New Space \u2014 she\u2019s the backbone of our lettings accounts department.\n\nKnown for her calm, kind and approachable nature, Yasaar always goes the extra mile to help landlords, tenants and colleagues alike. No matter how busy things get, she stays level-headed, organised and reassuring, making even the most complex accounts queries feel straightforward.\n\nA trusted and valued member of the team, her attention to detail and dedication keep everything on track behind the scenes. She\u2019s the person everyone turns to for a helping hand, a second opinion, or simply a calming influence.\n\nWhen she\u2019s not in the office, Yasaar\u2019s world revolves around her family. Most weekends are spent with loved ones \u2014 and she wouldn\u2019t have it any other way.\n\nSome offices have a \u2018voice of reason\u2019. At New Space, we have Yasaar.", photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/d5babra2_e24290fa-975d-462f-adb9-bcaa1ff5844b.jpg", imgPos: "44% 7%", photoHover: "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/gnkrscp3_a61973bc-9ef8-4d80-9a28-9a11f7b9fb7f.jpg", imgPosHover: "center 18%" },
  ],
};

export const TESTIMONIALS = [
  {
    quote:
      "After a good friend recommended them, New Space rented out my London Fields property within a week. The service, efficiency and conduct of the team surpasses any of the other agents in the area we\u2019ve worked with previously \u2014 and their fee structure is genuinely competitive, which every landlord appreciates.",
    author: "Amir",
  },
  {
    quote:
      "New Space have managed two properties in East London for me over the last six years. As a mortgage broker as well as a landlord, I know good service when I see it \u2014 and Richard and the team go above and beyond every time. They look after every detail and are always just one phone call away.",
    author: "Sarah",
  },
];

export const TESTIMONIAL_BG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_newspace-modern/artifacts/bn4rz1jb_image.webp";

// Lead long-form testimonials (large photo + full story), like the original page
export const LEAD_TESTIMONIALS = [
  {
    author: "Amir",
    role: "Landlord \u00b7 London Fields",
    photo: "https://www.newspaceuk.com/CMS/testimonial1.jpg",
    fallback:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    quote:
      "After a good friend of ours who lived in the area recommended them to us in 2015, New Space managed to rent out my London Fields property in the space of a week. The service, efficiency and conduct of the team were first class, not to mention the very competitive fee structure (which all landlords appreciate!). Fast forward 5 years and our opinion of New Space hasn\u2019t changed. Richard in Lettings and Kim in Property Management have been amazing and I honestly consider them as friends. When things run smoothly, Kim\u2019s team contact me only when required. But when issues occur, they are not afraid to dig in deep and will go the extra mile to resolve any issues and ensure the best outcome for those involved. We feel like our property is in the right hands and being truly cared for. Thank you New Space.",
  },
  {
    author: "Sarah",
    role: "Landlord & Mortgage Broker \u00b7 East London",
    photo: "https://www.newspaceuk.com/CMS/testimonial2.jpg",
    fallback:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    quote:
      "New Space have managed two properties in East London for me over the last six years. As a mortgage broker as well as a landlord, I\u2019m well attuned to levels of service in the property market and I can say with confidence that Richard and the New Space team go above and beyond for me. They look after every aspect of my properties, from marketing to finding tenants, managing the tenancy and making sure the flats are in good condition. What\u2019s different about New Space is the personal level of service they provide. I know that my property manager is always just one phone call away, and that he\u2019ll take care of finding the right people in the team to take care of whatever needs doing.",
  },
];

// Full list for the dedicated Testimonials page
export const REVIEWS = [
  {
    quote:
      "The level of experience and service surpasses any of the other agents in the area with whom we have worked previously.",
    author: "Amir",
    role: "Landlord, Hackney",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "The service, efficiency and conduct of the team are first class, not to mention the very competitive fee structure (which all landlords appreciate!)",
    author: "Sarah",
    role: "Landlord, De Beauvoir",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "Richard and the team found us a tenant within a week of listing. The whole process was smooth, professional and completely stress-free.",
    author: "James P.",
    role: "Landlord, London Fields",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1590086782792-42dd2350140d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "As a tenant, I was impressed by how responsive New Space were. Any maintenance issue was handled quickly through their app \u2014 brilliant service.",
    author: "Chloe M.",
    role: "Tenant, Dalston",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "We\u2019ve used several agents over the years but none come close to the personal attention New Space provide. Genuinely dependable people.",
    author: "David & Ruth",
    role: "Landlords, Stoke Newington",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1623366302587-b38b1ddaefd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    quote:
      "Honest, knowledgeable and always on the money with the rent accounting. I wouldn\u2019t hesitate to recommend them to any local landlord.",
    author: "Priya S.",
    role: "Landlord, Hackney Wick",
    rating: 5,
    photo: "https://images.pexels.com/photos/39087408/pexels-photo-39087408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  },
];

export const FEATURES = [
  {
    icon: "Users",
    color: "#35a4a4",
    title: "Excellent value",
    text: "As New Space client, you\u2019ll experience the same service levels offered by big players, but at much lower cost. This means high-quality marketing, a polished and streamlined process for finding tenants, and support from an experienced and dependable property management team.",
  },
  {
    icon: "Home",
    color: "#e6a41c",
    title: "Reliable management",
    text: "Our property management service is the best in the area. Your tenants will have great online systems for reporting tasks and paying rent, and you\u2019ll have access to trusted local tradesmen who charge reasonable rates. Our rent accounting is on the money and our arrears rate is close to zero.",
  },
  {
    icon: "KeyRound",
    color: "#35a4a4",
    title: "Lettings specialist",
    text: "Residential management and lettings are our core business. So we focus all our effort on doing them well. We\u2019ve been in the market for nearly 10 years. Today, we\u2019re relied on by both private and commercial landlords, who value our experience and reliability.",
  },
  {
    icon: "HeartHandshake",
    color: "#ec008c",
    title: "Personalised service",
    text: "Deal with real people rather than a corporate machine. Richard, our branch manager, will meet with you to provide a valuation, then stay involved throughout the letting. All of our lettings negotiators are invested in our ethos of personal service: it\u2019s why we\u2019ve mostly grown through word of mouth.",
  },
];

export const WHY_CHOOSE = {
  title: "Why Choose Us",
  intro:
    "With New Space, you\u2019re choosing first-class service without a premium price tag \u2013 and from an independent lettings specialist. We offer excellent value for money without compromising service.",
  bg: "https://images.unsplash.com/photo-1622109913183-42ce5f3767b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  points: [
    "High-quality marketing",
    "Streamlined process for finding and moving in tenants",
    "On-the-money rent accounting and near-zero arrears",
    "One senior, experienced property management contact",
    "Mobile app-based system to help tenants",
    "Excellent value local tradesmen",
    "One of the largest single-branch lettings operations in Hackney",
  ],
};

const GALLERY = {
  living1: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  living2: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchen1: "https://images.pexels.com/photos/10758468/pexels-photo-10758468.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  kitchen2: "https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bedroom: "https://images.pexels.com/photos/6903157/pexels-photo-6903157.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  bathroom: "https://images.pexels.com/photos/19916713/pexels-photo-19916713.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  exterior1: "https://images.unsplash.com/photo-1512845296467-183ccf124347?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  exterior2: "https://images.unsplash.com/photo-1525953776754-6c4b7ee655ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PROPERTIES = [
  {
    id: "nsl2-000002",
    tag: "Let",
    title: "Let - London, E15",
    address: "High Street, London, E15",
    area: "E15",
    price: "\u00a31,850 pcm",
    priceNum: 1850,
    image:
      "https://images.estatesit.uk/NEWSPACELONDON/PHOTOS/nsl2-000002-p-o-8e440360.jpg?size=480,320&format=webp",
    fallback:
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    gallery: [GALLERY.living1, GALLERY.kitchen1, GALLERY.bedroom, GALLERY.bathroom, GALLERY.exterior1],
    desc: "Welcome to this modern and well-kept one bedroom flat, perfectly positioned on the 5th floor and furnished exactly as shown in the photos. Step inside and you'll find a bright and stylish living space...",
    fullDesc: [
      "Welcome to this modern and well-kept one bedroom flat, perfectly positioned on the 5th floor and furnished exactly as shown in the photos. Step inside and you'll find a bright and stylish living space with floor-to-ceiling windows and far-reaching city views.",
      "The open-plan kitchen comes fully fitted with integrated appliances, while the generous double bedroom offers ample built-in storage. The contemporary bathroom is finished to a high standard throughout.",
      "Ideally located moments from Stratford's shops, transport links and green spaces, this is the perfect home for a professional couple or sharer.",
    ],
    beds: 1,
    baths: 1,
    receptions: 1,
    type: "Flat",
    furnished: "Furnished",
    available: "Available Now",
    deposit: "\u00a32,134",
    epc: "C",
  },
  {
    id: "nsl2-000005",
    tag: "New Instruction",
    title: "To Rent - London, E8",
    address: "Ellingfort Road, London, E8",
    area: "E8",
    price: "\u00a31,950 pcm",
    priceNum: 1950,
    image: GALLERY.living2,
    fallback:
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    gallery: [GALLERY.living2, GALLERY.kitchen2, GALLERY.bathroom, GALLERY.exterior2],
    desc: "Welcome to the studio flat that proves size isn't everything (except when it comes to built-in storage, in which case, you've got plenty). This ground floor wonder is so well laid out...",
    fullDesc: [
      "Welcome to the studio flat that proves size isn't everything (except when it comes to built-in storage, in which case, you've got plenty). This ground floor wonder is so well laid out you'll be amazed by how much living space has been cleverly created.",
      "A sleek modern kitchen sits alongside a comfortable sleeping and living area, with a stylish shower room completing the picture. Every inch has been thoughtfully designed.",
      "Set on a quiet residential road in the heart of London Fields, you're a short stroll from the park, Broadway Market and Hackney Central's excellent transport links.",
    ],
    beds: 0,
    baths: 1,
    receptions: 1,
    type: "Flat",
    furnished: "Furnished",
    available: "Available Now",
    deposit: "\u00a32,250",
    epc: "D",
  },
  {
    id: "nsl2-000004",
    tag: "New Instruction",
    title: "To Rent - London, SW5",
    address: "Earls Court, London, SW5",
    area: "SW5",
    price: "\u00a33,100 pcm",
    priceNum: 3100,
    image:
      "https://images.estatesit.uk/NEWSPACELONDON/PHOTOS/nsl2-000004-p-o-64bc54a2.jpg?size=480,320&format=webp",
    fallback:
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    gallery: [GALLERY.living1, GALLERY.kitchen1, GALLERY.bedroom, GALLERY.living2, GALLERY.bathroom, GALLERY.exterior1],
    desc: "Discover this fabulous two-bedroom flat situated in a striking period conversion, offering refreshingly light accommodation with beautiful wood floors and contemporary fittings. The flat...",
    fullDesc: [
      "Discover this fabulous two-bedroom flat situated in a striking period conversion, offering refreshingly light accommodation with beautiful wood floors and contemporary fittings throughout.",
      "The flat comprises a spacious reception room, a separate fully-fitted kitchen, two generous double bedrooms and a modern family bathroom. High ceilings and large sash windows flood the home with natural light.",
      "Perfectly positioned in the heart of Earls Court, you're moments from the underground, an array of restaurants and the open spaces of Holland Park.",
    ],
    beds: 2,
    baths: 1,
    receptions: 1,
    type: "Flat",
    furnished: "Part-furnished",
    available: "Available from 1st October",
    deposit: "\u00a33,577",
    epc: "C",
  },
];

export const PRICE_OPTIONS = [
  "900", "1,000", "1,100", "1,200", "1,300", "1,400",
  "1,500", "1,750", "2,000", "2,250", "2,500", "3,000", "3,500", "4,000",
  "4,500", "5,000", "6,000", "8,000", "10,000",
];

export const FOOTER = {
  about:
    "We\u2019re an established independent lettings and management specialist based in Haggerston. From here, we cover London Fields, Dalston, De Beauvoir, Hoxton, Stoke Newington, Hackney Central, Hackney Wick and Clapton.",
  usefulLinks: ["Property to Rent", "Areas We Cover", "Contact Us", "Property Alerts", "Property Valuation", "HMO & Licensing Guide"],
  areas: ["London Fields", "Dalston", "Hackney Wick", "Islington", "The City", "Shoreditch", "Stoke Newington"],
  legal:
    "Managed Exit Ltd T/A New Space UK | 266 Kingsland Road, London E8 4DG | Company Number: 06631310 | VAT Number: 975741674 | Property Redress Scheme: Property Ombudsman | Client Money Protection Provided by UKALA Membership No: 18882",
};

export const CONTACT = {
  address: "266 Kingsland Road, London E8 4DG",
  phone: "020 7275 2040",
  email: "info@newspaceuk.com",
};
